import { type FunctionComponent } from "react";

import { SvgFallback } from "./SvgFallback";
import { SvgStyled } from "./SvgModel.styles";

interface SvgProps {
    assetPath: string;
    brandColor?: string | null;
    fallbackPath: string;
}

export const SvgModel: FunctionComponent<SvgProps> = ({ assetPath, fallbackPath, brandColor }) => {
    return (
        <SvgStyled
            src={assetPath}
            brandColor={brandColor}
            fallback={() => <SvgStyled src={fallbackPath} brandColor={brandColor} fallback={SvgFallback} />}
        />
    );
};
